/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMSignInPayload } from '@/data/types/GTM';

export const getGTMSignInEventData = async (payload: GTMSignInPayload) => ({
	method: payload.method,
	settings: payload.settings,
});
